import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_EMBED_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1982.1559974316274!2d25.04675177785884!3d60.21124954011695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46920927d3baff55%3A0xa48fce89d5102f09!2sSilva%20Mysterium%20Oy!5e0!3m2!1sfi!2sfi!4v1754849635305!5m2!1sfi!2sfi';

export default function GMap({ src = DEFAULT_EMBED_SRC, height = '400px', className }) {
  return (
    <section style={{ height }} className={className}>
      <iframe
        title="Map"
        src={src}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </section>
  );
}

GMap.propTypes = {
  src: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string
};